const FLOW_TYPES = {
  old: 'old',
  mvp: 'mvp',
  revamp_2023: 'revamp_2023'
}

// Agent app version to update when we deploy a new version
// Naming: [Type of flow].[Major update].[Minor update]
export const AGENT_APP_VERSION = `${FLOW_TYPES.revamp_2023}.1.3`
